// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'code';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='m5.722 3.375-4.83 4.83a1.125 1.125 0 0 0 0 1.59l4.83 4.83m6.556-11.25 4.83 4.83a1.125 1.125 0 0 1 0 1.59l-4.83 4.83'
  />
);

export const viewBox = '0 0 18 18';
